import {
  ActionEmptyState,
  Button,
  Card,
  CardContent,
  DataTable,
  Typography,
} from "@/components/ui";
import { getDashboardMostRecentMattersColumns } from "@/components/ui/DashboardMostRecentMattersCard/dashboard-most-recent-matters-columns";
import { RecentMatterRowContextMenu } from "@/components/ui/DashboardMostRecentMattersCard/RecentMatterRowContextMenu";
import { retrieveRecentMattersQueryOptions } from "@/lib/data/react-query/matters/recent-matters";
import { tanstackTableNames } from "@/lib/data/static/tanstack-table-names";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";
import { useMemo } from "react";

export const DashboardMostRecentMattersCard = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery(
    retrieveRecentMattersQueryOptions(),
  );

  const columns = useMemo(() => getDashboardMostRecentMattersColumns(), []);

  const recentMatters = data?.data ?? [];

  return (
    <Card>
      <CardContent className="w-full pt-4">
        <div className="mb-4 ml-2">
          <Typography variant="heading" color="primary">
            Most recent matters
          </Typography>
        </div>
        <DataTable
          entityLabelPlural="matters"
          allowLocalStorage={false}
          hideSearchBar
          hideVisiibilityDropdown
          columns={columns}
          data={recentMatters}
          onRowClick={async (row) => {
            const matterId = row.original.id;
            if (!matterId) return;

            await navigate({
              to: "/matters/$matterId",
              params: { matterId },
            });
          }}
          renderRowContextMenu={(row, trigger) => (
            <RecentMatterRowContextMenu
              recentMatter={row.original}
              trigger={trigger}
            />
          )}
          tableName={tanstackTableNames.mostRecentMatters}
          isLoading={isLoading}
          isError={Boolean(error)}
          noResultsMessage="No recent matters found."
          noResultsContent={
            <ActionEmptyState
              icon={<ClipboardList className="h-5 w-5" />}
              title="No recent matters yet"
              description="Once you open a matter, it will appear here for quick return visits."
              actions={
                <Button asChild size="sm">
                  <Link to="/matters">View matters</Link>
                </Button>
              }
            />
          }
        />
      </CardContent>
    </Card>
  );
};
